module.exports = __webpack_public_path__ + "img/04.6e5e245b.jpg";